import { createHttpClient } from '@adapters/HttpClient';
import { apiClientWH } from '@shared/services/ApiClient';
import { useQuery } from '@tanstack/react-query';
import { useMemo } from 'react';
import { WalletAccountingSyncApiAdapter } from '../adapters';
import type { WalletAccountingSyncTransactionDetail } from '../models';

export const useWalletAccountingSyncDetail = (transactionId: number | null) => {
  const httpClient = useMemo(() => createHttpClient(apiClientWH), []);
  const adapter = useMemo(() => new WalletAccountingSyncApiAdapter(httpClient), [httpClient]);

  return useQuery<WalletAccountingSyncTransactionDetail, Error>({
    queryKey: ['wallet-accounting-sync-transaction', transactionId],
    queryFn: () => adapter.getDetail(transactionId as number),
    enabled: typeof transactionId === 'number' && !Number.isNaN(transactionId),
    staleTime: 60 * 1000,
  });
};
